module.exports = __webpack_public_path__ + "static/media/Pedidos5.e4cf32e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos5.png
// module id = 1783
// module chunks = 0